<template>
  <StepPage
    :page="page"
    :input="wordmark"
    :loading="loading"
    name="Business Name"
    @continue="saveWordmark"
  >
    <TextInput
      v-model="wordmark"
      autofocus
      maxlength="30"
      data-hj-whitelist
      :status="wordmarkValidationStatus"
      :status-message="wordmarkValidationError"
      :label="label"
      :placeholder="placeholder"
      :prompt="page.input.prompt"
      :disabled="loading"
      input-styles="form-input-large"
      @enter="saveWordmark"
    />
  </StepPage>
</template>

<script>
import { mapState } from 'vuex'
import RenderVariables from '@/mixins/prismic/helpers/render-variables'
import { wordmark_validator } from '@/lib/constants/validators'
import { errorMessage } from '@/lib/helpers/error-messages'
import TextInput from '@/components/form/TextInput'
import { meta } from '@/mixins/content'
import { EventBus, Events } from '@/lib/events'
import StepPage from '@/components/StepPage'
import delay from '@/mixins/delay-page'
import BusinessNameContent from '@/content/business-name'

export default {
  transition: 'fade',

  layout: 'progress',

  components: { StepPage, TextInput },

  mixins: [RenderVariables, delay(), meta],

  data: () => ({
    page: BusinessNameContent,
    submittingForm: false,
    form_error: '',
    wordmark: '',
  }),

  computed: {
    placeholder() {
      return this.enterprise ? this.render(this.page?.input?.placeholder) : ''
    },

    label() {
      return this.enterprise ? this.render(this.page?.input?.label) : ''
    },

    wordmarkValidationError() {
      return errorMessage(this.$v.wordmark, this.page?.input?.field_name)
    },

    wordmarkValidationStatus() {
      return this.$v.wordmark.$error ? 'error' : null
    },

    loading() {
      return this.submittingForm || !this.pageReady
    },

    ...mapState(['enterprise']),
  },

  validations: { wordmark: wordmark_validator },

  created() {
    this.wordmark = this.$store.state.session.wordmark
  },

  mounted() {
    // Trigger validation when wordmark is set through query params, or a returning customer
    if (this.wordmark.length > 0) {
      this.$v?.$touch()
    }

    EventBus.$emit(Events.StepSetProgress, 15)
  },

  methods: {
    async saveWordmark() {
      if (this.$invalidInput() || this.submittingForm) {
        return
      }

      this.submittingForm = true
      try {
        if (this.wordmark !== this.$store.state.session.wordmark) {
          this.$store.commit('session/setWordmark', this.wordmark)
          this.$store.commit('editor/SET_UNVALIDATED_WORDMARK', this.wordmark)
          this.$store.dispatch('app/refreshLogos')
        }

        this.$router.push(this.localePath('/slogan'))
      } catch {
        this.submittingForm = false
      }
    },
  },
}
</script>
